import createQueryStore from './createQueryStore';

const store = createQueryStore('subscriptionProducts');

export default store.reducer;
export const actions = store.actions;
export const useProductsStore = store.useStore;
